<template>
  <div class="app-container">
    <BjPage
      ref="BjPage"
      :query-params="queryParams"
      :get-action="queryApi"
      :selection="selection"
      :col-span="colSpan"
      :serial="serial"
      :before-reset-search="beforeResetSearch"
      :tooltip-config="{ showAll: false, enterable: false }"
      @handleSelectionChange="handleSelectionChange"
      @showSetting="SortableTable.show"
      @header-dragend="SortableTable.handleHeaderDragend"
      @header-contextmenu="SortableTable.handleHeaderContextmenu"
    >
      <template v-slot:baseForm>
        <!-- 客户名称 -->
        <el-col :span="colSpan" v-if="!$store.getters.cusId">
          <el-form-item :label="$t('billingPage.CustomerName')" prop="cusId">
            <BjSelectLov v-model="queryParams.cusId" :option-list="customerList" :placeholder="$t('customerNameText')" />
          </el-form-item>
        </el-col>
        <!-- 开始时间 -->
        <el-col :span="colSpan">
          <el-form-item :label="$t('AccountManagementAdd.onTime')" prop="queryParamsTime_start">
            <BjDateRangePicker v-model="queryParamsTime_start" :placeholder="$t('AccountManagementAdd.onTime')" />
          </el-form-item>
        </el-col>
        <!-- 操作人 -->
        <el-col :span="colSpan">
          <el-form-item :label="$t('workOrderList.Operator')" prop="operater">
            <BjInput
              v-model="queryParams.operater"
              :maxlength="MAX_LENGTH.DEFAULT"
              :placeholder="$t('workOrderList.Operator')"
              clearable
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
        </el-col>
      </template>

      <template v-slot:tableOperation>
        <el-col>
          <el-button type="primary" @click="onAdd">{{ $t('addText') }}</el-button>
        </el-col>
      </template>

      <!-- 展示列表 -->
      <template v-slot:tableColumn>
        <template v-for="(col, index) in dropCols">
          <el-table-column v-if="col.prop !== 'bjTableAction'"
          :key="`col_${index}_${col.prop}_${col.width || 'auto'}`"
          :prop="col.prop"
          :label="col.label"
          :width="col.width || 'auto'"
          :fixed="col.fixed || false"
          align="center"
          class-name="item"
          :show-overflow-tooltip="col.prop !== 'bjTableAction'">
            <template slot-scope="scope">
              <template v-if="false" />
              <template v-else-if="col.prop == 'cusId'">{{ customerList.bjGet(scope.row.cusId) }}</template>
              <template v-else-if="col.prop === 'status'">
                {{  scope.row[col.prop] == '0' ? $t('InStorage') : scope.row[col.prop] == '1' ? $t('completedText') : scope.row[col.prop] == '2' ? $t('canceledText') : '' }}
              </template>
              <span v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</span>
            </template>
          </el-table-column>
          <el-table-column v-if="col.prop === 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || 'right'" align="center">
            <template slot-scope="props">
                <el-button type="text" class="edit-btn" @click="onEdit(props.row)">{{$t('editText')}}</el-button>
                <el-button type="text" class="edit-btn" @click="onOut(props.row)">{{ $t('billingPage.OUTBOUND')}}</el-button>
                <el-button type="text" class="delete-btn" @click="onDel(props.row)">{{ $t('BusinessPurchaseOrderList.Abandoned')}}</el-button>
            </template>
          </el-table-column>
        </template>
      </template>
    </BjPage>
    <!-- 新增/编辑弹窗 -->
    <DataForm ref="DataForm" @reFresh="reFresh" />
    <!-- 出库弹窗 -->
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="$t('billingPage.OUTBOUND')"
      :visible.sync="addDialogVisible"
      width="500px"
      :before-close="handleClose"
    >
      <el-form ref="form" :model="form" status-icon :rules="rules" label-width="100px">
        <el-form-item :label="$t('billingPage.endDate')" prop="endTime">
          <el-date-picker
            v-model="form.endTime"
            type="datetime"
            format="yyyy-MM-dd HH:mm"
            :placeholder="$t('billingPage.endDate')"
            :picker-options="pickerOptions"
            >
        </el-date-picker>
      </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">{{ $t('cancelText') }}</el-button>
        <el-button type="primary" @click="submitForm('form')">{{ $t('okText') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import pageMiXin from '@/utils/page-mixin.js';
import { purchaseApi } from '@/api';
import DataForm from './components/DataForm.vue';
import moment from 'moment';

export default {
  name: 'BusinessPurchaseTemporaryNot',
  components: {
    DataForm
  },
  mixins: [pageMiXin],
  data() {
    return {
      selection: false,
      colSpan: 4,
      // 查询参数
      queryApi: purchaseApi.getPurchaseTemporaryList,
      queryParamsTime_start: [],
      queryParams: {
        cusId: this.$store.getters.cusId || null,
        statusList: ['0'],
        startTimeBegin: null,
        startTimeEnd: null,
        operater: null,
      },
      // 操作人下拉列表
      userIdNameList:[],

      labelList1: [
        { label: this.$t('billingPage.CustomerName'), prop: 'cusId', isCheck: true, disabled: false },
        { label: this.$t('billingPage.PalletQty'), prop: 'palletQty', isCheck: true, disabled: false },
        { label: this.$t('AccountManagementAdd.status'), prop: 'status', isCheck: true, disabled: false },
        { label: this.$t('billingPage.startDate'), prop: 'startTime', isCheck: true, disabled: false },
        { label: this.$t('BjDialogListConfig.Operator'), prop: 'operater', isCheck: true, disabled: false },
        { label: this.$t('table.operationText'), prop: 'bjTableAction', isCheck: true, disabled: false },
      ],
      addDialogVisible: false,
      // 表单数据
      form:{endTime:null},
      // 表单校验
      rules: {
        endTime: [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
      },
      pickerOptions: {
        // 限制时间选择今天及以后的
        disabledDate(time) {
          return time.getTime() > new Date().getTime();
        },
      },
    };
  },
  computed: {
    labelList() {
        return this.$store.getters.cusId ? this.labelList1.filter(item => item.prop != 'cusId') : this.labelList1;
      },
  },
  watch: {
    // 开始日期
    queryParamsTime_start(v) {
        this.queryParams.startTimeBegin = (v || [])[0];
        this.queryParams.startTimeEnd = (v || [])[1];
    },
  },
  methods: {
    /** 新建 */
    onAdd() {
      this.$refs.DataForm.show();
    },
    /** 编辑 */
    onEdit(row) {
      this.$refs.DataForm.show(this.$lodash.clone(row));
    },
    /** 出库 */
    onOut(row) {
      this.addDialogVisible = true;
      this.pickerOptions = {
          disabledDate(time) {
              return time.getTime() > new Date().getTime() || time.getTime() < new Date(row.startTime).getTime();
          },
      };
      this.form.endTime = null;
      this.form.id = row.id;
      this.form.objectVersionNumber = row.objectVersionNumber;
      this.$nextTick(() => {
        this.$refs.form.clearValidate();
      });
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (!valid) return this.$scrollToFormError();
        let POST_DATA = {
          cusId: this.$store.getters.cusId || null,
          id: this.form.id,
          objectVersionNumber:this.form.objectVersionNumber,
          status:'1',
          endTime: moment(this.form.endTime).format('YYYY-MM-DD HH:mm:ss'),
        };
        purchaseApi.modifyPurchaseTemporaryList(POST_DATA).then(res => {
          if (!res.failed) {
            this.$message.success(this.$t('toast.operationSuccessText'));
            setTimeout(() => {
              this.addDialogVisible = false;
              this.reFresh();
            }, 500);
          }
        });
      });
    },
    handleClose() {
      this.addDialogVisible = false;
    },
    /** 废弃 */
    onDel(row) {
      let API_DATA = {
        cusId: this.$store.getters.cusId || null,
        id: row.id,
        objectVersionNumber: row.objectVersionNumber,
        status: '2',
      };
      this.$confirm(this.$t('InternalSalesOrderDetails.want'), this.$t('toast.hintText'), {
        confirmButtonText: this.$t('toast.okText'),
        cancelButtonText: this.$t('toast.cancelText'),
        type: 'warning',
      }).then(() => {
          purchaseApi.modifyPurchaseTemporaryList(API_DATA).then(res => {
          if (!res.failed) {
            this.$message.success(this.$t('toast.operationSuccessText'));
            setTimeout(() => {
              this.reFresh();
            }, 500);
          }
        });
      })
    },


    /** 重置按钮操作 */
    beforeResetSearch() {
      this.queryParamsTime_start = null;
      return new Promise(resolve => {
        resolve();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .bj-page .el-form-item__label{
  display: none;
}
</style>
